export const GET_COURSE_VIEW_TEMPLATE = "GET_COURSE_VIEW_TEMPLATE";
export const SET_COURSE_VIEW_TEMPLATE = "SET_COURSE_VIEW_TEMPLATE";
export const GET_CARD_COURSE_COUNT = "GET_CARD_COURSE_COUNT";
export const SET_CARD_COURSE_COUNT = "SET_CARD_COURSE_COUNT";
export const GET_COURSE_INSTANCE_VIEW_TEMPLATE = "GET_COURSE_INSTANCE_VIEW_TEMPLATE";
export const SET_COURSE_INSTANCE_VIEW_TEMPLATE = "SET_COURSE_INSTANCE_VIEW_TEMPLATE";

export const DELETE_COURSE_TEMPLATE = "DELETE_COURSE_TEMPLATE";
export const SET_DELETE_COURSE_TEMPLATE = "SET_DELETE_COURSE_TEMPLATE";
export const SET_SELECTED_CARD = "SET_SELECTED_CARD";

export const DELETE_COURSE_INSTANCE = "DELETE_COURSE_INSTANCE";
export const SET_DELETE_COURSE_INSTANCE = "SET_DELETE_COURSE_INSTANCE";

export const getCourseViewTemplate = (params: any) => ({
  type: GET_COURSE_VIEW_TEMPLATE,
  payload: params,
});

export const setCourseViewTemplate = (data: any) => ({
  type: SET_COURSE_VIEW_TEMPLATE,
  payload: data,
});

export const getCardCourseCount = () => ({
  type: GET_CARD_COURSE_COUNT,
});

export const setCardCourseCount = (data: any) => ({
  type: SET_CARD_COURSE_COUNT,
  payload: data,
});

export const getCourseInstanceViewTemplate = (params: any) => ({
  type: GET_COURSE_INSTANCE_VIEW_TEMPLATE,
  payload: params,
});

export const setCourseInstanceViewTemplate = (data: any) => ({
  type: SET_COURSE_INSTANCE_VIEW_TEMPLATE,
  payload: data,
});


export const deleteCourseTemplate = (params: any) => ({
  type: DELETE_COURSE_TEMPLATE,
  payload: params,
});

export const setDeleteCourseTemplate = (data: any) => ({
  type: SET_DELETE_COURSE_TEMPLATE,
  payload: data,
});

export const setSelectedCard = (cardId: number) => ({
  type: SET_SELECTED_CARD,
  payload: cardId,
});

export const deleteCourseInstance = (params: any) => ({
  type: DELETE_COURSE_INSTANCE,
  payload: params,
});

export const setDeleteCourseInstance = (data: any) => ({
  type: SET_DELETE_COURSE_INSTANCE,
  payload: data,
});
